export default "__VITE_ASSET__hO68rJNw__"